import React, { useEffect, useState, useRef } from 'react';
import { ROUTE_CONTRACTS_PAGE } from "../../routes/Routes";
import { useNavigate } from "react-router-dom";
import { ToolbarForm } from '../toolbar-form/toolbar-form'
import { ContractFormDetails } from './ContractFormDetails';
import ValidationGroup from 'devextreme-react/validation-group';
import PutPostPatchFetch from '../../hooks/PutPostPatchFetch';
import BaseNotification from '../BaseNotification/BaseNotification';
import './ContractForm.scss';

/** @typedef {import('../../types/contract').Contract} Contract */

/**
 * @param {Contract} data 
 * @param {boolean} isLoading 
 * @param {boolean} isEditing 
 */

export const ContractForm = ({ data, isEditing, isLoading = false }) => {
    const navigate = useNavigate();
    const navigateToContractPage = () => navigate(ROUTE_CONTRACTS_PAGE.withSlash);
    const [editing, setEditing] = useState(isEditing);
    const [formData, setFormData] = useState(data);
    const [notification, setNotification] = useState({
        message: '',
        type: undefined,
        visible: false
    });
    const isNew = data["ContractId"] == 0;
    const dataRef = useRef(null);


    useEffect(() => {
        setFormData(data);
    }, [data]);

    const handleEditClick = (e) => {
        if (editing === false && formData) {
            dataRef.current = formData;
        } else {
            dataRef.current = undefined;
        }
        setEditing(!editing);
    };

    const onSaveClick = async ({ validationGroup }) => {
        var formValid = validationGroup.validate().isValid;

        if (formValid === false) return;

        if (formValid === true) {
            setEditing(false);

            let result;
            if (isNew) {
                result = await PutPostPatchFetch('/v1/Contract/AddContract', 'POST', formData); 
            }
            else
                result = await PutPostPatchFetch('/v1/Contract/EditContract', 'PUT', formData);

            if (result?.Success) {
                setNotification({
                    message: isNew ? 'New contract was saved, successfully.' : `Contract ${formData.ContractNumber} was updated successfully.`,
                    type: 'success',
                    visible: true
                });
            };

            if (result?.Errors.length > 0) {
                setNotification({
                    message: result?.Errors[0].Message ?? 'Contract was not saved.',
                    type: 'error',
                    visible: true
                });
            };
        }
    };

    const onBackClick = () => {
        navigateToContractPage();
    };

    const onCancelClick = () => {
        if (isNew) {
            navigateToContractPage();
        }
        else {
            setFormData(dataRef.current);
            handleEditClick();
        }
    };

    const updateField = (field, value) => {
        if (!formData) return;
        formData[field] = value;
    };

    const updateObject = (item, key, field, value) => {
        if (!formData) return;
        formData[item][key] = { ...formData[item][key], [field]: value };
    };


    return (
        <div className='contact-form'>
            <ValidationGroup>
                <ToolbarForm toggleEditing={handleEditClick} onSaveClick={onSaveClick} editing={editing} onBackClick={onBackClick} onCancelClick={onCancelClick} />
                <ContractFormDetails
                    loading={isLoading}
                    hasData={!formData}
                    data={formData}
                    editing={editing}
                    updateField={updateField}
                    updateObject={updateObject}
                />
            </ValidationGroup>
            <BaseNotification 
                message={notification.message}
                ref={useRef(null)}
                setter={() => setNotification(() => (
                    { 
                        isVisible: false,
                        message: '',
                        type: undefined
                    }
                ))}
                type={notification.type}
                visible={notification.visible}
            />
        </div>
    );
};